import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createAsyncThunk } from '@reduxjs/toolkit';
import { MessageStatus, errorConverter, getBlobFile } from "../../../../shared/api";
import { getImageSize } from "../../../../shared/lib";
import { updateMessage } from "./store";
export var getFileThunk = createAsyncThunk('file/generateFile', /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, _ref2) {
    var url, message, dispatch, rejectWithValue, fileBlob, fileUrl;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          url = _ref.url, message = _ref.message;
          dispatch = _ref2.dispatch, rejectWithValue = _ref2.rejectWithValue;
          _context.prev = 2;
          _context.next = 5;
          return getBlobFile(url);
        case 5:
          fileBlob = _context.sent;
          fileUrl = URL.createObjectURL(fileBlob);
          dispatch(updateMessage({
            id: message.messageId,
            date: message.date,
            messageStatus: MessageStatus.delivered,
            message: {
              fileUrl: fileUrl
            }
          }));
          return _context.abrupt("return", fileUrl);
        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", rejectWithValue(errorConverter(_context.t0)));
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 11]]);
  }));
  return function (_x, _x2) {
    return _ref3.apply(this, arguments);
  };
}());
export var getImageThunk = createAsyncThunk('file/generateFile', /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref4, _ref5) {
    var _message$message;
    var url, message, dispatch, rejectWithValue, isPreviewImg, fileBlob, imageSettings, srcFile, key;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          url = _ref4.url, message = _ref4.message;
          dispatch = _ref5.dispatch, rejectWithValue = _ref5.rejectWithValue;
          isPreviewImg = (_message$message = message.message) === null || _message$message === void 0 ? void 0 : _message$message.filePreviewUrl;
          _context2.prev = 3;
          dispatch(updateMessage({
            id: message.messageId,
            date: message.date,
            messageStatus: MessageStatus.download
          }));
          _context2.next = 7;
          return getBlobFile(url);
        case 7:
          fileBlob = _context2.sent;
          _context2.next = 10;
          return getImageSize(fileBlob);
        case 10:
          imageSettings = _context2.sent;
          srcFile = URL.createObjectURL(fileBlob); // Если нет filePreviewUrl => устанавливаем key 'filePreviewUrl'
          key = isPreviewImg ? 'fileUrl' : 'filePreviewUrl';
          dispatch(updateMessage({
            id: message.messageId,
            date: message.date,
            messageStatus: MessageStatus.delivered,
            message: _objectSpread(_defineProperty({}, key, srcFile), isPreviewImg ? {
              imageSettings: imageSettings
            } : {})
          }));
          return _context2.abrupt("return", {
            srcFile: srcFile,
            imageSettings: imageSettings
          });
        case 17:
          _context2.prev = 17;
          _context2.t0 = _context2["catch"](3);
          dispatch(updateMessage({
            id: message.messageId,
            date: message.date,
            messageStatus: isPreviewImg ? MessageStatus.failed : MessageStatus.refresh
          }));
          return _context2.abrupt("return", rejectWithValue(errorConverter(_context2.t0)));
        case 21:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[3, 17]]);
  }));
  return function (_x3, _x4) {
    return _ref6.apply(this, arguments);
  };
}());